export default __webpack_public_path__ + "static/media/postgresqlback.c8aae889.svg";